import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import { Collapse, Input, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Form,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';

export default class Story extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      canSubmit: false,
      submitFailed: false,
      submitSuccess: false
    };
  }

  setInputState = (event) => {
  	this.setState({
  		[event.target.name]: event.target.value
  	}, () => { this.setValidationState(); });
  }

  setValidationState = () => {
	let emailValidated = false;
	this.validateEmail(this.state.email) ? emailValidated = true : emailValidated = false;
	this.setState({ canSubmit: emailValidated });
  }

  submitForm = () => {
  	this.state.canSubmit 
  	? this.successfulSubmission() 
  	: this.failedSubmission()
  }

  successfulSubmission = () => {
  	this.sendEmail();

  	this.setState({
	  	email: "",
	  	canSubmit: false,
	  	submitFailed: false,
	  	submitSuccess: true
	  });

  }
  failedSubmission = () => {
  	this.setState({
  		submitFailed: true,
  		submitSuccess: false
  	});
  }

  sendEmail = () => {
    var URL = 'https://y80ewecumi.execute-api.us-east-1.amazonaws.com/prod/connect';
         
    var emailData = {
      email: this.state.email
    };

    fetch(URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      body: JSON.stringify({emailData})
    })
    .then(function (response) {
      //console.log('Response: ' + response.json());
    })
    .then(function (result) {
      //console.log('Result: ' + result);
    })
    .catch(function(error) {
      //console.log('Error: ' + error);
    });
  }

  validateEmail = (value) => {
  	var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  	return regex.test(value);
  }

  render() {
    return (
		<Container_s fluid>
			<Container_1000 className={this.state.submitFailed && !this.state.canSubmit ? "has-danger" : ""}>

				<h4>GET CONNECTED</h4>
				<a target="_blank" href="https://www.facebook.com/Primitives-Candles-1616540168633493/">
					<img src={require("../media/facebook.jpg")}></img>
				</a>
				
				<p>Get email offers & the latest news from Primitives Candles.</p>
				<Form>
					<Input name="email" placeholder="Email" autoComplete="email"
						state={this.state.submitFailed && !this.state.canSubmit ? "danger" : ""}
						value={this.state.email} onChange={this.setInputState} />
					<FormFeedback_s submitFailed={this.state.submitFailed} canSubmit={this.state.canSubmit}>
						Please enter a valid email to connect with us.
					</FormFeedback_s>
					<Button onClick={this.submitForm} size="md">
						SUBMIT
					</Button>
					<FormFeedback_success submitSuccess={this.state.submitSuccess} >
						Email has been submitted successfully. Thank you!
					</FormFeedback_success>
				</Form>
			</Container_1000>
			
		</Container_s>
		);
	}
}

const Container_s = styled(Container)`
	padding: 20px 15px 50px 15px!important;
	text-align: center;
`;

const Container_1000 = styled(Container)`
	margin: 0 auto!important;
	padding: 0!important;

	h4 {
		margin-bottom: 5px;
		font-weight: bold;
		font-size: 30px;
		text-align: left;
	}
	a {
		width: 24px;
		height: 24px;
		display: block;
		margin-bottom: 20px;

		img {
			width: 100%;
			height: 100%;
		}
	}
	p {
		font-size: 16px;
		font-family: 'Raleway';
		${media.lg`
			font-size: 18px;
		`}
		max-width: 500px;
		margin: 0 auto;
		padding-bottom: 10px;
		text-align: left;
		margin-left: 0;
	}

	Input {
		margin-bottom: 15px;
		border: 1px solid #996633;
		color: #4d2600;
		font-family: 'Raleway';
		:-webkit-autofill, :-webkit-autofill:hover, :-webkit-autofill:active, :-webkit-autofill:focus { transition: background-color 5000s ease-in-out 0s; }

		&:focus {
			border: 1px solid #996633;
		}
	}

	Button {
		cursor: pointer;
		display: block;
		color: white!important;
		border: 0px!important;
		box-shadow: none;
		background-color: #8B572A;
		font-family: 'Raleway';
		font-size: 14px;
		font-weight: bold;
		${media.lg`
			font-size: 16px;
		`}

	      :hover {
	        background-color: #dfbf9f;
	      }
	      :focus {
	        box-shadow: none;
	      }
	      :active {
	        background-color: #dfbf9f;
	      }
	}

`;

const FormFeedback_s = styled(({ submitFailed, canSubmit, ...rest }) => <FormFeedback {...rest} />)`
	text-align: left;
	margin-bottom: 11px;
	display: ${props => props.submitFailed && !props.canSubmit ? "block!important" : "none!important"};
	font-size: 16px!important;
    ${media.md` font-size: 18px!important; `}
`;

const FormFeedback_success = styled(({ submitSuccess, ...rest }) => <FormFeedback {...rest} />)`
	text-align: left;
	color: green!important;
	display: ${props => props.submitSuccess ? "block!important" : "none!important"};
	font-size: 16px!important;
  	${media.md` font-size: 18px!important; `}
`;


// WEBPACK FOOTER //
// ./src/components/Connect.js